import { TotalTime } from "./TotalTime";
export default TotalTime;
